/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Cognito API
 * Bank Relationship Management - Cognito
 * OpenAPI spec version: v1
 */
import type {
  GetApiV1HolidaysDateAfterWorkingDays200,
  GetApiV1HolidaysDateAfterWorkingDaysParams,
  GetApiV1HolidaysDateBeforeWorkingDays200,
  GetApiV1HolidaysDateBeforeWorkingDaysParams,
  GetApiV1HolidaysEndDateFromWorkingDays200,
  GetApiV1HolidaysEndDateFromWorkingDaysParams,
  GetApiV1HolidaysHolidaysInRange200,
  GetApiV1HolidaysHolidaysInRangeParams,
  GetApiV1HolidaysIsHoliday200,
  GetApiV1HolidaysIsHolidayParams,
  GetApiV1HolidaysIsWorkingDay200,
  GetApiV1HolidaysIsWorkingDayParams,
  GetApiV1HolidaysNextWorkingDay200,
  GetApiV1HolidaysNextWorkingDayParams,
  GetApiV1HolidaysWorkingDaysList200,
  GetApiV1HolidaysWorkingDaysListParams,
  GetApiV1HolidaysYearMonth200,
  PostApiV1HolidaysCalculateWorkingDays200,
  PostApiV1HolidaysCountWorkingDays200,
  RequestNumberOfWorkingDaysHolidayDto,
  RequestWorkingDaysDto
} from '../schemas';

import { customInstance } from '.././mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getNationalHoliday = () => {
/**
 * Este endpoint retorna uma lista de feriados para o mês e ano especificados.
Cada feriado é retornado com detalhes como identificador único, nome do feriado, e a data específica.
 * @summary Obtém todos os feriados de um mês e ano específicos.
 */
const getHolidaysYearMonth = (
    year: number,
    month: number,
 options?: SecondParameter<typeof customInstance<GetApiV1HolidaysYearMonth200>>,) => {
      return customInstance<GetApiV1HolidaysYearMonth200>(
      {url: `/api/v1/holidays/${year}/${month}`, method: 'GET'
    },
      options);
    }
  /**
 * Este endpoint retorna todos os dias úteis considerando sábados, domingos e feriados como não úteis.
 * @summary Retorna uma lista de todos os dias úteis dentro de um intervalo especificado.
 */
const getHolidaysWorkingDaysList = (
    params?: GetApiV1HolidaysWorkingDaysListParams,
 options?: SecondParameter<typeof customInstance<GetApiV1HolidaysWorkingDaysList200>>,) => {
      return customInstance<GetApiV1HolidaysWorkingDaysList200>(
      {url: `/api/v1/holidays/working-days-list`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este endpoint calcula e retorna a próxima data útil, útil para planejamento e agendamentos.
 * @summary Obtém o próximo dia útil após uma data especificada, desconsiderando sábados, domingos e feriados.
 */
const getHolidaysNextWorkingDay = (
    params?: GetApiV1HolidaysNextWorkingDayParams,
 options?: SecondParameter<typeof customInstance<GetApiV1HolidaysNextWorkingDay200>>,) => {
      return customInstance<GetApiV1HolidaysNextWorkingDay200>(
      {url: `/api/v1/holidays/next-working-day`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este endpoint é útil para calcular prazos que levam em conta apenas dias úteis.
 * @summary Calcula a data que será alcançada após adicionar um número especificado de dias úteis a partir de uma data inicial.
 */
const getHolidaysDateAfterWorkingDays = (
    params?: GetApiV1HolidaysDateAfterWorkingDaysParams,
 options?: SecondParameter<typeof customInstance<GetApiV1HolidaysDateAfterWorkingDays200>>,) => {
      return customInstance<GetApiV1HolidaysDateAfterWorkingDays200>(
      {url: `/api/v1/holidays/date-after-working-days`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este endpoint é útil para calcular prazos que levam em conta apenas dias úteis.
 * @summary Calcula a data que será alcançada após subtrair um número especificado de dias úteis a partir de uma data inicial.
 */
const getHolidaysDateBeforeWorkingDays = (
    params?: GetApiV1HolidaysDateBeforeWorkingDaysParams,
 options?: SecondParameter<typeof customInstance<GetApiV1HolidaysDateBeforeWorkingDays200>>,) => {
      return customInstance<GetApiV1HolidaysDateBeforeWorkingDays200>(
      {url: `/api/v1/holidays/date-before-working-days`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este endpoint facilita a visualização dos feriados em um intervalo de datas, auxiliando no planejamento.
 * @summary Retorna uma lista de todos os feriados dentro de um intervalo de datas específico.
 */
const getHolidaysHolidaysInRange = (
    params?: GetApiV1HolidaysHolidaysInRangeParams,
 options?: SecondParameter<typeof customInstance<GetApiV1HolidaysHolidaysInRange200>>,) => {
      return customInstance<GetApiV1HolidaysHolidaysInRange200>(
      {url: `/api/v1/holidays/holidays-in-range`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este endpoint é útil para determinar se uma data específica é considerada um dia útil para operações ou agendamentos.
 * @summary Verifica se uma data específica é um dia útil, desconsiderando sábados, domingos e feriados.
 */
const getHolidaysIsWorkingDay = (
    params?: GetApiV1HolidaysIsWorkingDayParams,
 options?: SecondParameter<typeof customInstance<GetApiV1HolidaysIsWorkingDay200>>,) => {
      return customInstance<GetApiV1HolidaysIsWorkingDay200>(
      {url: `/api/v1/holidays/is-working-day`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este endpoint verifica se uma data ou um intervalo entre a data de início e a data final é um feriado.
Se apenas a data de início é fornecida, verifica-se apenas essa data. Se a data final também é fornecida,
o sistema verifica se qualquer dia no intervalo é um feriado.
 * @summary Verifica se uma data específica é um feriado.
 */
const getHolidaysIsHoliday = (
    params?: GetApiV1HolidaysIsHolidayParams,
 options?: SecondParameter<typeof customInstance<GetApiV1HolidaysIsHoliday200>>,) => {
      return customInstance<GetApiV1HolidaysIsHoliday200>(
      {url: `/api/v1/holidays/is-holiday`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este endpoint calcula a data final a partir de um número específico de dias úteis fornecido,
considerando feriados e finais de semana.
 * @summary Calcula a data final considerando um número específico de dias úteis.
 */
const getHolidaysEndDateFromWorkingDays = (
    params?: GetApiV1HolidaysEndDateFromWorkingDaysParams,
 options?: SecondParameter<typeof customInstance<GetApiV1HolidaysEndDateFromWorkingDays200>>,) => {
      return customInstance<GetApiV1HolidaysEndDateFromWorkingDays200>(
      {url: `/api/v1/holidays/end-date-from-working-days`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este endpoint recebe um objeto que define um intervalo de datas e retorna o número de dias úteis dentro deste intervalo,
considerando sábados, domingos e feriados como não úteis. É possível especificar se o dia inicial e o dia final devem ser
incluídos no cálculo. A resposta inclui o número total de dias úteis.
 * @summary Calcula o número de dias úteis dentro de um período especificado, considerando feriados.
 */
const postHolidaysCalculateWorkingDays = (
    requestNumberOfWorkingDaysHolidayDto?: RequestNumberOfWorkingDaysHolidayDto,
 options?: SecondParameter<typeof customInstance<PostApiV1HolidaysCalculateWorkingDays200>>,) => {
      return customInstance<PostApiV1HolidaysCalculateWorkingDays200>(
      {url: `/api/v1/holidays/calculate-working-days`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestNumberOfWorkingDaysHolidayDto
    },
      options);
    }
  /**
 * Este endpoint recebe um objeto com datas de início e fim e retorna o número total de dias úteis no intervalo especificado.
Dias úteis são calculados excluindo sábados, domingos e feriados. Esta operação é útil para planejamento de prazos e cálculos de períodos de trabalho.
 * @summary Calcula o número de dias úteis entre duas datas.
 */
const postHolidaysCountWorkingDays = (
    requestWorkingDaysDto?: RequestWorkingDaysDto,
 options?: SecondParameter<typeof customInstance<PostApiV1HolidaysCountWorkingDays200>>,) => {
      return customInstance<PostApiV1HolidaysCountWorkingDays200>(
      {url: `/api/v1/holidays/count-working-days`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestWorkingDaysDto
    },
      options);
    }
  return {getHolidaysYearMonth,getHolidaysWorkingDaysList,getHolidaysNextWorkingDay,getHolidaysDateAfterWorkingDays,getHolidaysDateBeforeWorkingDays,getHolidaysHolidaysInRange,getHolidaysIsWorkingDay,getHolidaysIsHoliday,getHolidaysEndDateFromWorkingDays,postHolidaysCalculateWorkingDays,postHolidaysCountWorkingDays}};
export type GetApiV1HolidaysYearMonthResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getNationalHoliday>['getHolidaysYearMonth']>>>
export type GetApiV1HolidaysWorkingDaysListResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getNationalHoliday>['getHolidaysWorkingDaysList']>>>
export type GetApiV1HolidaysNextWorkingDayResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getNationalHoliday>['getHolidaysNextWorkingDay']>>>
export type GetApiV1HolidaysDateAfterWorkingDaysResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getNationalHoliday>['getHolidaysDateAfterWorkingDays']>>>
export type GetApiV1HolidaysDateBeforeWorkingDaysResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getNationalHoliday>['getHolidaysDateBeforeWorkingDays']>>>
export type GetApiV1HolidaysHolidaysInRangeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getNationalHoliday>['getHolidaysHolidaysInRange']>>>
export type GetApiV1HolidaysIsWorkingDayResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getNationalHoliday>['getHolidaysIsWorkingDay']>>>
export type GetApiV1HolidaysIsHolidayResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getNationalHoliday>['getHolidaysIsHoliday']>>>
export type GetApiV1HolidaysEndDateFromWorkingDaysResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getNationalHoliday>['getHolidaysEndDateFromWorkingDays']>>>
export type PostApiV1HolidaysCalculateWorkingDaysResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getNationalHoliday>['postHolidaysCalculateWorkingDays']>>>
export type PostApiV1HolidaysCountWorkingDaysResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getNationalHoliday>['postHolidaysCountWorkingDays']>>>
